import { z } from 'zod';

export const SearchFormSchema = z.object({
  // BasicInfoTab fields
  ngay_bc: z.string().optional(),
  ngay_tt: z.string().optional(),
  ngay_ct1: z.string().optional(),
  ngay_ct2: z.string().optional(),
  tk: z.string().optional(),

  // DetailTab fields
  ma_kh: z.string().optional(),
  nh_kh1: z.string().optional(),
  nh_kh2: z.string().optional(),
  nh_kh3: z.string().optional(),
  rg_code: z.string().optional(),
  ct_theo: z.string().optional(),
  tt_yn: z.string().optional(),
  so_ngay_tt: z.number().optional(),
  so_ngay_cb: z.number().optional(),
  mau_bc: z.string().optional(),

  // OtherTab fields
  so_ct1: z.string().optional(),
  so_ct2: z.string().optional(),
  report_filtering: z.string().optional(),
  data_analysis_struct: z.string().optional()
});

export type SearchFormValues = z.infer<typeof SearchFormSchema>;

export const initialSearchValues: SearchFormValues = {
  // BasicInfoTab initial values
  ngay_bc: new Date().toISOString().split('T')[0],
  ngay_tt: new Date().toISOString().split('T')[0],
  tk: '',

  // DetailTab initial values
  ma_kh: '',
  nh_kh1: '',
  nh_kh2: '',
  nh_kh3: '',
  rg_code: '',
  ct_theo: '1', // Default to "Theo hóa đơn"
  tt_yn: '1', // Default to "Chỉ có hóa đơn số dư lớn hơn 0"
  so_ngay_tt: 30,
  so_ngay_cb: 0,
  mau_bc: '20', // Default to "Mẫu tiền chuẩn"

  // OtherTab initial values
  so_ct1: '',
  so_ct2: '',
  report_filtering: '0', // Default to "Người dùng tự lọc"
  data_analysis_struct: '0' // Default to "Không phân tích"
};
